/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { language } from "config";
import { makeStyles } from "@material-ui/core/styles";
import UsersCombo from "../../components/UsersCombo";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import AlertDialog from "../../components/AlertDialog";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Input,
  Row,
  Col,
} from "reactstrap";
import { TextField } from "@material-ui/core";
import { FirebaseContext } from "common";const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  container: {
    zIndex: "12",
    color: "#FFFFFF",
    alignContent: "center",
  },
  title: {
    color: "#000",
  },
  gridcontainer: {
    alignContent: "center",
  },
  items: {
    margin: 0,
    width: "100%",
  },
  input: {
    fontSize: 18,
    color: "#000",
  },
  inputdimmed: {
    fontSize: 18,
    color: "#737373",
  },
  practicephoto: {
    height: "18px",
    marginRight: "10px",
  },
  buttonStyle: {
    margin: 0,
    width: "100%",
    height: "100%",
  },
  rootTwo: {
    minWidth: 275,
    borderRight: "2px solid",
    borderRightColor: "#ff0000",
    borderBlockStartColor: "#ff0000",
    borderBlockStart: "2px solid",
    // background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  },
}));

const BrokerEnquiryInformation = (props) => {
  ////////////////////REduX////////////////////
  const { api } = useContext(FirebaseContext);
  const { GetDateString, updateBooking, fetchChatMessages, clearLoginError } =
    api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  // const Booking?.Medical_Information? = useSelector(
  //   (state) => state.medicalRecords.medicalHistoryRecords
  // );
  ////////////////////constant////////////////////
  const Booking = (props.location && props.location.state.Booking) || {};
  const [updatebooking, setupdatebooking] = useState(Booking);
  const usersdata = useSelector((state) => state.brokers);
  const [Brokers, setBrokers] = useState([]);

  const [Landlords, setLandlords] = useState([]);
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [rejectbuttonclicked, setrejectbuttonclicked] = useState(false);
  const [acceptbuttonclicked, setacceptbuttonclicked] = useState(false);
  const [commonAlert, setCommonAlert] = useState({
    open: false,
    msg: "",
    title: "",
  });

  useEffect(() => {
    let arr = [];
    usersdata.users.map((user) => {
      if (
        user.practiceNumber === auth.info.profile.practiceNumber &&
        user.userType === "broker"
      ) {
        arr.push({
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.mobile,
          email: user.email,
          uid: user.id,
          profile_image: user.profile_image,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            user.mobile +
            ") " +
            user.email,
          pushToken: user.pushToken,
        });
      }
    });
    setBrokers(arr);
  }, []);

  useEffect(() => {
    let arr = [];
    usersdata.users.map((user) => {
      if (
        user.practiceNumber === auth.info.profile.practiceNumber &&
        user.userType === "landlord"
      ) {
        arr.push({
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.mobile,
          email: user.email,
          uid: user.id,
          profile_image: user.profile_image,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            user.mobile +
            ") " +
            user.email,
          pushToken: user.pushToken,
        });
      }
    });
    setLandlords(arr);
  }, []);

  /////////////useeffect used for the reject button & accept button//////////////
  useEffect(() => {
    if (rejectbuttonclicked === true) {
      dispatch(updateBooking(updatebooking));
      props.history.push("/bookingrequest");
    } else {
      if (acceptbuttonclicked === true) {
        if (updatebooking.status === "ACCEPTED") {
          setCommonAlert({
            open: true,
            msg: "You have accepted your booking, please be ready 10 mintues before your booking",
            title: "Thank you",
          });
        } else {
          props.history.push("/bookingrequest");
        }

        dispatch(updateBooking(updatebooking));
      }
    }
  }, [rejectbuttonclicked, acceptbuttonclicked]);

  //////////////functions needed for code to run//////////////
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    if (updatebooking.status === "ACCEPTED") {
      props.history.push("/bookingrequest");
    }
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const HandleReject = () => {
    if (auth.info.profile.userType === "tenant") {
      setupdatebooking({ ...updatebooking, status: "NEW", broker: null });
      setrejectbuttonclicked(true);
    }
  };
  const HandleAccept = () => {
    if (Booking.status === "PENDING") {
      setupdatebooking({ ...updatebooking, status: "ACCEPTED" });
      setacceptbuttonclicked(true);
    } else {
      setupdatebooking({ ...updatebooking, status: "PENDING" });
      setOpen(false);
      setacceptbuttonclicked(true);
    }
  };
  const closeMed = () => {
    setOpen(false);
  };
  //////////////////////Render the alert Dialog/////////////////
  const renderAlertDialog = () => {
    return (
      <AlertDialog
        open={commonAlert.open}
        onClose={handleCommonAlertClose}
        title={commonAlert.title}
      >
        {commonAlert.msg}
      </AlertDialog>
    );
  };

 
  const renderBookingData = () => {
    return (
      <Row>
        <Col>
          <FormGroup>
            <span>User Details: </span>
            <p className="description">{"Enquiries.userdetials.email"}</p>
          </FormGroup>

          <FormGroup>
            <span>Location: </span>
            <p className="description">{"Enquiries.location"}</p>
          </FormGroup>

          <FormGroup>
            <span>Other information: </span>
            <p className="description">{"Enquiries.OtherInfo"}</p>
          </FormGroup>

          <FormGroup>
            <span>Type of Build : </span>
            <p className="description">{"Enquiries.TypeOfBuilding"}</p>
          </FormGroup>

          <FormGroup>
            <span>Type of Buy: </span>
            <p className="description">{"Enquiries.TypeOfBuy"}</p>
          </FormGroup>
        </Col>
      </Row>
    );
  };
  const renderButtons = () => {
    return (
      <Col md="12">
        <Row>
          
            <Col md="2">
              <Button
                color="primary"
                onClick={() => {
                  HandleAccept();
                }}
              >
                Back
              </Button>
            </Col>
        </Row>
      </Col>
    );
  };
  return (
    <Card>
      <CardHeader>
        <CardTitle tag="h4">Enquiry Details</CardTitle>
      </CardHeader>
      <CardBody>
        {renderAlertDialog()}
        {renderBookingData()}
      </CardBody>
      <CardFooter>{renderButtons()}</CardFooter>
    </Card>
  );
};

export default BrokerEnquiryInformation;
